import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../AppActions';

const F = AppActions.F;

export default function TeamPersonnel(props) {
  const {data} = props;

  if (!data) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>{F(data, 'title')}</h2>
      </div>
      <div className="container">
        <div className="image-only-item">
          <img
            alt={data.image_organization}
            src={F(data, 'image_organization')}
            style={{width: '100%'}}
          />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 60px;

  & > .title {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  & > .container {
  }

  .image-only-item {
    margin-bottom: 10px;
    padding: 10px;
  }
`;
